module.exports = __webpack_public_path__ + "img/3_148.73c047cf.png";